import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import { Close, PersonSearch } from '@mui/icons-material';
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import UserStore from '../../store/UserStore';
import LoadingProgressStore from '../../store/LoadingProgressStore';
import LeadStore from '../../store/LeadStore';
import AuthStore from '../../store/AuthStore';
import { CustomStyledButton, CustomStyledDialog, isEmptyObject } from '../../utils/helper';
import { useLocation } from 'react-router-dom';

export const SendNotificationSubOwnerDialog = observer(
  ({
    headerLabel,
    toggleSendNotificationDialog,
    handleToggleNotifyUserDialog,
    selectedLeads,
    refreshLeadersBoard = false,
  }) => {
    const location = useLocation();
    const [selectedUserToNotify, setSelectedUserToNotify] = useState(null);
    const [usersList, setUsersList] = useState([]);
    const [isSendNotificationError, setIsSendNotificationError] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const pipelineId = queryParams.get('pId');

    useEffect(() => {
      if (toggleSendNotificationDialog) {
        UserStore.fetchUsersDropDown();
        LoadingProgressStore.toggleIsLoading(true);
      }
    }, [toggleSendNotificationDialog]);

    useEffect(() => {
      setUsersList([...UserStore.users]);
      LoadingProgressStore.toggleIsLoading(false);
    }, [UserStore.users]);

    useEffect(() => {
      const notifyAutoCompleteContainer = document.querySelector('#notify-user-autocomplete');
      if (notifyAutoCompleteContainer) {
        notifyAutoCompleteContainer.querySelector('fieldset').style.borderColor = isSendNotificationError
          ? '#ff0000'
          : 'rgba(0, 0, 0, 0.23)';
        notifyAutoCompleteContainer.querySelector('label').style.color = isSendNotificationError
          ? '#ff0000'
          : 'rgba(0, 0, 0, 0.6)';
      }
    }, [isSendNotificationError]);

    useEffect(() => {
      LeadStore.leadAssignedStatus && handleToggleNotifyUserDialog(false);
    }, [LeadStore.leadAssignedStatus]);

    useEffect(() => {
      LeadStore.leadAssignedStatus && refreshLeadersBoard && LeadStore.setRefreshLeadersBoard();
    }, [LeadStore.leadAssignedStatus]);

    const handleNotifyUser = () => {
      debugger
      LeadStore.updateLeadSubOwner({
        userId: selectedUserToNotify.id,
        actionUserId: AuthStore.userDetails.Id,
        pipeLineId: pipelineId,
        leadIds: selectedLeads,
      });
    };

    return (
      <CustomStyledDialog
        open={toggleSendNotificationDialog}
        onClose={(event, reason) => reason !== 'backdropClick' && handleToggleNotifyUserDialog(false)}
        fullWidth={true}
        maxWidth={'xs'}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            if (!selectedUserToNotify) {
              setIsSendNotificationError(true);
              return;
            }
            handleNotifyUser();
          },
        }}
      >
        <DialogTitle>
          <Stack>
            <Typography sx={{ fontWeight: '700' }} component="p">
              {headerLabel}
            </Typography>
          </Stack>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => handleToggleNotifyUserDialog(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          <div id="notify-user-autocomplete">
            <Autocomplete
              sx={{ pt: '10px' }}
              size="small"
              options={usersList}
              renderOption={(props, option) => <li {...props}>{option.userName}</li>}
              getOptionLabel={(option) => {
                return option.userName;
              }}
              onChange={(event, value) => {
                setSelectedUserToNotify(value);
                setIsSendNotificationError(!value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select user"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment sx={{ borderRight: '1px #000 solid' }} position="start">
                        <IconButton>
                          <PersonSearch />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </div>
        </DialogContent>
        <DialogActions sx={{ p: '20px', justifyContent: 'center' }}>
          <CustomStyledButton
            variant="contained"
            disabled={isEmptyObject(selectedUserToNotify)}
            type="submit"
            autoFocus
          >
            Confirm
          </CustomStyledButton>
        </DialogActions>
      </CustomStyledDialog>
    );
  }
);